import { Action } from '@ngrx/store';
import {LicenseListFilters} from '../license-mgt.model';

export enum ListFilterActionTypes {
  LoadLicenseListFilters = '[LicenseListFilter] Load ListFilters',
  SelectLicenseListFilters = '[LicenseListFilter] Select ListFilters'
}

export class LoadListFilters implements Action {
  readonly type = ListFilterActionTypes.LoadLicenseListFilters;
}

export class SelectLicenseListFilters implements Action {
  readonly type = ListFilterActionTypes.SelectLicenseListFilters;
  constructor(public payload: LicenseListFilters) {}
}



export type LicenseMgtListFilterActions = LoadListFilters
  | SelectLicenseListFilters;
